module.exports = __webpack_public_path__ + "img/marie-christine-gill.c157a862.jpg";